import { render, staticRenderFns } from "./LabElementCreate.vue?vue&type=template&id=bf2abeaa"
import script from "./LabElementCreate.vue?vue&type=script&lang=js"
export * from "./LabElementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf2abeaa')) {
      api.createRecord('bf2abeaa', component.options)
    } else {
      api.reload('bf2abeaa', component.options)
    }
    module.hot.accept("./LabElementCreate.vue?vue&type=template&id=bf2abeaa", function () {
      api.rerender('bf2abeaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labElement/LabElementCreate.vue"
export default component.exports